export default "__VITE_ASSET__RpvQKX82__"